import styles from '../auto-insurance-matches.module.scss';
import { formatCamelCase } from '../utils';

type MatchesFiltersChipProps = {
  label: string;
  onDelete: () => void;
};

const MatchesFiltersChip = ({ label, onDelete }: MatchesFiltersChipProps) => {
  return (
    <div className={styles.filtersChip}>
      <span className={styles.filtersChipLabel}>{formatCamelCase(label)}</span>
      <button
        type="button"
        onClick={onDelete}
        className={styles.filtersChipDeleteButton}
        aria-label="Remove filter"
      >
        ✕
      </button>
    </div>
  );
};

export default MatchesFiltersChip;
